import { TaskStatus, TaskType } from './project-config'

// Mirrors Common.Core.Enums.EPatchType with local extensions used by DevTracker.
export const RELEASE_NOTES_PATCH_TYPES = [
  'bugfix',
  'new_feature',
  'feature_enhancement',
  'ui_enhancements',
  'new_function_product',
] as const

export type ReleaseNotesPatchType = typeof RELEASE_NOTES_PATCH_TYPES[number]

export const RELEASE_NOTES_PATCH_TYPE_LABELS: Record<ReleaseNotesPatchType, string> = {
  bugfix: 'BugFix',
  new_feature: 'NewFeature',
  feature_enhancement: 'FeatureEnhancement',
  ui_enhancements: 'UIEnhancements',
  new_function_product: 'NewFunctionProduct',
}

// Maps task type values used in DevTracker to release note patch types.
export const TASK_TYPE_TO_RELEASE_PATCH_TYPE: Record<TaskType, ReleaseNotesPatchType> = {
  bugfix: 'bugfix',
  new_feature: 'new_feature',
  feature_enhancement: 'feature_enhancement',
  ui_enhancements: 'ui_enhancements',
  new_function_product: 'new_function_product',
}

// Mirrors Common.Core.Enums.EPatchNotesStatus.
export const RELEASE_NOTES_STATUSES = ['scheduled', 'released', 'failed'] as const

export type ReleaseNotesStatus = typeof RELEASE_NOTES_STATUSES[number]

export const RELEASE_NOTES_STATUS_LABELS: Record<ReleaseNotesStatus, string> = {
  scheduled: 'Scheduled',
  released: 'Released',
  failed: 'Failed',
}

// Requested status mapping:
// scheduled = ready_for_prod, released = released_to_prod.
// failed has no direct task status in the current task workflow.
export const RELEASE_NOTES_STATUS_TO_TASK_STATUS: Record<ReleaseNotesStatus, TaskStatus | null> = {
  scheduled: 'ready_for_prod',
  released: 'released_to_prod',
  failed: null,
}

export const TASK_STATUS_TO_RELEASE_NOTES_STATUS: Partial<Record<TaskStatus, ReleaseNotesStatus>> = {
  ready_for_prod: 'scheduled',
  released_to_prod: 'released',
}

// Mirrors Common.Core.Enums.EApplicationEnum.
export const RELEASE_NOTES_APPLICATIONS = [
  'IQSuite',
  'EnrolIQ',
  'ClockIQ',
  'ReportIQ',
  'TenantIQ',
  'VisitorIQ',
  'GuestIQ',
] as const

export type ReleaseNotesApplication = typeof RELEASE_NOTES_APPLICATIONS[number]

// Maps DevTracker related-app display names to the release-notes application enum.
export const RELATED_APP_TO_RELEASE_NOTES_APPLICATION: Record<string, ReleaseNotesApplication | null> = {
  'IQSuite.cloud': 'IQSuite',
  'IQSuite.cloud Admin': 'IQSuite',
  'EnrolIQ.cloud': 'EnrolIQ',
  'ClockIQ.cloud': 'ClockIQ',
  'ReportIQ.cloud': 'ReportIQ',
  'TenantIQ.cloud': 'TenantIQ',
  'VisitorIQ.cloud': 'VisitorIQ',
  'GuestIQ.cloud': 'GuestIQ',
}

export const RELEASE_NOTES_CONFIG = {
  patchTypes: RELEASE_NOTES_PATCH_TYPES,
  patchTypeLabels: RELEASE_NOTES_PATCH_TYPE_LABELS,
  statuses: RELEASE_NOTES_STATUSES,
  statusLabels: RELEASE_NOTES_STATUS_LABELS,
  applications: RELEASE_NOTES_APPLICATIONS,
} as const
